import type {
  GetKeywordsParams,
  Keyword,
  KeywordCreateRequest,
  KeywordUpdateRequest,
  KeywordsResponse,
} from '@/types/keywords';
import { ApiService } from './api.service';

class KeywordsService extends ApiService {
  public async getKeywords(params: GetKeywordsParams = {}): Promise<KeywordsResponse> {
    const queryParams = new URLSearchParams();
    if (params.cursor) queryParams.append('cursor', params.cursor);
    if (params.limit) queryParams.append('limit', params.limit.toString());

    const url = `/api/v1/keywords${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await this.get<KeywordsResponse>(url);
    return response.data;
  }

  public async getKeyword(id: string): Promise<Keyword> {
    const url = `/api/v1/keywords/${id}`;
    const response = await this.get<Keyword>(url);
    return response.data;
  }

  public async createKeyword(data: KeywordCreateRequest): Promise<Keyword> {
    const url = '/api/v1/keywords';
    const response = await this.post<Keyword>(url, data);
    return response.data;
  }

  public async updateKeyword(id: string, data: KeywordUpdateRequest): Promise<Keyword> {
    const url = `/api/v1/keywords/${id}`;
    const response = await this.put<Keyword>(url, data);
    return response.data;
  }

  public async deleteKeyword(id: string): Promise<void> {
    const url = `/api/v1/keywords/${id}`;
    await this.delete<void>(url);
  }
}

export const keywordsService = new KeywordsService();
